import { render, staticRenderFns } from "./commission-range.vue?vue&type=template&id=c9b7935c&scoped=true"
import script from "./commission-range.vue?vue&type=script&lang=ts"
export * from "./commission-range.vue?vue&type=script&lang=ts"
import style0 from "./commission-range.vue?vue&type=style&index=0&id=c9b7935c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b7935c",
  null
  
)

export default component.exports